

let fromSerie = false;
let durationTemporal = null;

const geDuration= function() {
    return durationTemporal;
};
const setDuration = function(value) {
    durationTemporal = value;
};

const setIsFromSerie = function(value) {
    fromSerie = value;
};
const getIsFromSerie = function() {
    return fromSerie;
};

const FlagTimeOut = {
    setIsFromSerie,
    getIsFromSerie,
    setDuration,
    geDuration
};

export default FlagTimeOut;



// WEBPACK FOOTER //
// ./src/AAF/TimeoutAAF/FlagTimeOut.js